import React, { useRef } from 'react';
import { toast } from 'react-toastify';

import { Form } from '@unform/web';
import { isArray } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { SimpleDialog } from '~/components';
import { t } from '~/helpers';
import api from '~/services/api';

import MyForm from './form';
import { Container } from './styles';

export default function ChangePassword({ password, close }) {
  const formRef = useRef(null);

  async function handleSubmit(params) {
    try {
      const schema = Yup.object().shape({
        senhaatual: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        senhanova: Yup.string().
          trim(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio'))
          .min(4, t('s.geral.validacao.tamanhominimo').replace('%s', 4))
          .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
          ,
        senhanovaconfirmada: Yup.string().trim().test(
          'passwords-match',
          'Senha não confere',
          function (value) {
            return this.parent.senhanova === value;
          }
        ),
      });

    await schema.validate(params, {
      abortEarly: false,
    });

    await api
      .put('alterasenhausuario', params)
      .then(async () => {
        toast.success(t('s.geral.sucessoalteracao'));
        await close();
      })
      .catch((err) => {
        if (isArray(err)) {
          err.map((erro) => toast.error(erro));
        } else {
          toast.error(err);
        }
      });
  } catch (err) {
    const validationErrors = {};

    if (err instanceof Yup.ValidationError) {
      err.inner.forEach((error) => {
        validationErrors[error.path] = error.message.replace(
          `${error.path} `,
          ''
        );
      });

      formRef.current.setErrors(validationErrors);
    }
  }
}

return (
  <SimpleDialog
    open={password}
    toggleOpen={() => close()}
    title="Alterar senha"
    cancell={() => close(false)}
    submit={() => formRef.current.submitForm()}
  >
    <Form ref={formRef} onSubmit={handleSubmit}>
      <Container>
        <MyForm />
      </Container>
    </Form>
  </SimpleDialog>
);
}

ChangePassword.propTypes = {
  password: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};
